(function () {
  'use strict';
  var drawer = document.querySelector('[data-side-cart]');
  if (!drawer || !drawer.showModal || drawer.dataset.prelaunch === 'true') return;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, ready = false, opener, previousOverflow;
  var status = drawer.querySelector('[data-cart-status]');
  var retry = drawer.querySelector('[data-cart-retry]');
  var couponCode = '', couponMessage = '', couponOpen = false;
  async function request(path, data) {
    var response = await fetch(base + path, {method:data ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers:{'Content-Type':'application/json',Accept:'application/json'},body:data ? JSON.stringify(data) : undefined});
    var body = await response.json();
    if (!response.ok) throw new Error(body.description || 'تعذّر تحديث السلة. حاول تحديثها مرة أخرى.');
    return body;
  }
  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-cart-change], [data-cart-upgrade], [data-cart-swap], [data-cart-combine], [data-cart-checkout] button, [data-cart-retry]').forEach(function (el) { el.disabled = value || !ready; });
    retry.disabled = value;
  }
  function show() {
    if (!drawer.open) {
      opener = document.activeElement;
      previousOverflow = document.body.style.overflow;
      drawer.showModal();
      document.body.style.overflow = 'hidden';
      drawer.querySelector('[data-cart-close]').focus();
    }
  }
  function close() { drawer.close(); }
  drawer.addEventListener('close', function () { document.body.style.overflow = previousOverflow || ''; if (opener && opener.isConnected) opener.focus(); });
  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) { var r = drawer.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); }
    if (event.target.closest('[data-cart-close]')) close();
    var control = event.target.closest('[data-cart-change]');
    if (control && !busy) update(function () { return request('cart/change.js',{id:control.dataset.key,quantity:Number(control.dataset.cartChange)}); });
    if (event.target.closest('[data-cart-retry]') && !busy) update();
    var up = event.target.closest('[data-cart-upgrade]');
    if (up && !busy) update(function () { return request('cart/change.js',{id:up.dataset.key,quantity:Number(up.dataset.qty)||2}); });
    // upgrade to the offer: add the offer line first, then remove what it replaces, so nothing is lost if the add fails
    var swap = event.target.closest('[data-cart-swap]');
    if (swap && !busy) {
      var pick = drawer.querySelector('input[name="cx2"]:checked');
      if (pick) update(async function () { await request('cart/add.js',{items:[{id:Number(pick.value),quantity:1}]}); return request('cart/change.js',{id:swap.dataset.key,quantity:0}); });
    }
    var combine = event.target.closest('[data-cart-combine]');
    if (combine && !busy) update(async function () { await request('cart/add.js',{items:[{id:Number(combine.dataset.add),quantity:1}]}); return request('cart/update.js',{updates:JSON.parse(combine.dataset.updates)}); });
    if (event.target.closest('[data-cart-apply]') && !busy && ready) applyCoupon();
  });
  drawer.addEventListener('change',function(event){
    if (event.target.name !== 'cx2') return;
    var label = drawer.querySelector('[data-cx2-name]');
    if (label) label.textContent = event.target.dataset.name;
  });
  drawer.addEventListener('keydown',function(event){
    if (event.key === 'Enter' && event.target.id === 'side-cart-code') {event.preventDefault();if(!busy && ready)applyCoupon();}
  });
  async function applyCoupon() {
    couponCode = drawer.querySelector('#side-cart-code').value.trim();
    couponOpen = true;
    if (!couponCode) {couponMessage='يرجى إدخال كود الخصم.';paintCoupon();return;}
    await update(async function(){
      var cart = await request('cart/update.js',{discount:couponCode});
      var codes = (cart.discount_codes || []).filter(function(c){return c.applicable;}).map(function(c){return c.code;});
      (cart.cart_level_discount_applications || []).forEach(function(a){codes.push(a.title);});
      (cart.items || []).forEach(function(i){(i.line_level_discount_allocations || []).forEach(function(a){codes.push(a.discount_application.title);});});
      var accepted = codes.some(function(c){return String(c).toLowerCase() === couponCode.toLowerCase();});
      couponMessage=accepted?'✓ تم تطبيق الكود بنجاح.':'الكود غير صالح لهذه السلة، أو لا يمكن جمعه مع الخصم الحالي.';
      if(!accepted)couponCode='';
    });
    paintCoupon();
  }
  function paintCoupon(){
    var details=drawer.querySelector('.side-cart__coupon'), input=drawer.querySelector('#side-cart-code'), message=drawer.querySelector('[data-cart-coupon-status]');
    if(!details)return;
    details.open=couponOpen;
    input.value=couponCode;
    message.textContent=couponMessage;message.hidden=!couponMessage;
  }
  async function render(cart) {
    var response = await fetch(base + '?section_id=cart-drawer', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('تعذّر عرض السلة. حاول تحديثها مرة أخرى.');
    var html = new DOMParser().parseFromString(await response.text(),'text/html');
    var content = html.querySelector('[data-cart-content]');
    if (!content) throw new Error('تعذّر عرض السلة. حاول تحديثها مرة أخرى.');
    drawer.querySelector('[data-cart-content]').replaceWith(content);
    paintCoupon();
    document.querySelectorAll('.cart-count').forEach(function (el) {el.textContent=cart.item_count;el.hidden=!cart.item_count; if (el.parentElement) el.parentElement.setAttribute('aria-label','سلة التسوق، '+cart.item_count+' منتجات');});
  }
  async function reconcile() { return {cart: await request('cart.js')}; }
  async function update(mutation) {
    if (busy) return;
    ready = false; setBusy(true); status.hidden = false; status.textContent = 'جارٍ تحديث السلة…'; retry.hidden = true;
    try {
      var operation = async function () { if (mutation) await mutation(); return reconcile(); };
      var result = navigator.locks ? await navigator.locks.request('am-cart',operation) : await operation();
      await render(result.cart);
      ready = true; status.hidden = true;
    } catch (error) { status.textContent = error.message || 'تعذّر تحديث السلة.'; retry.hidden = false; }
    finally { setBusy(false); }
  }
  document.addEventListener('click',function(event) {
    var link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    var url = new URL(link.href,location.origin);
    if (url.origin === location.origin && url.pathname === base+'cart') { event.preventDefault(); show(); update(); }
  });
  document.addEventListener('submit',function(event) {
    var form = event.target;
    if (form.matches('[data-cart-checkout]')) {
      if (!ready || busy) {event.preventDefault();return;}
      event.preventDefault();
      updateCheckout(form);
      return;
    }
    var formId = form.getAttribute('id');
    if (formId !== 'product-form' && formId !== 'cart-up') return;
    if (event.defaultPrevented) return;
    event.preventDefault();
    if (busy) return;
    var data = new FormData(form), item = {id:data.get('id'),quantity:Number(data.get('quantity') || 1)};
    var props = {};
    data.forEach(function(value,key){var match=key.match(/^properties\[(.*)\]$/);if(match)props[match[1]]=value;});
    if (Object.keys(props).length) item.properties=props;
    if (data.get('selling_plan')) item.selling_plan=data.get('selling_plan');
    var items = [item];
    try { var multi = JSON.parse(data.get('items_json') || 'null'); if (multi && multi.length) items = multi; } catch (e) {}
    show(); update(function(){return request('cart/add.js',{items:items});});
  });
  async function updateCheckout(form) {
    setBusy(true);
    try { await request('cart/update.js',{attributes:{'Terms notice shown':'yes · '+new Date().toISOString()}}); location.href=base+'checkout'; }
    catch(error) { ready=false;status.hidden=false;status.textContent=error.message;retry.hidden=false;setBusy(false); }
  }
  // open on the cart page itself, so /cart never shows a second, different cart
  if (location.pathname.replace(/\/$/, '') === (base + 'cart').replace(/\/$/, '')) { show(); update(); }
})();
